import logo from './logo.svg';
import './App.css';
import  {PluginDetail} from './plugin/plugin-detail'

function App() {
  return (
    <div className="App">
        <PluginDetail/>
    </div>
  );
}

export default App;
